export default class ErrorPayload {
  constructor(_nativeError, _message, _status) {
    this.nativeError = _nativeError;
    this.message = _message;
    this.status = _status;
  }
}
